import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { PageShell } from '@/components/generals/page-shell'
import { ContactMasthead } from '@/components/contact/contact-masthead'
import { ContactBody } from '@/components/contact/contact-body'
import { ContactClosing } from '@/components/contact/contact-closing'

const Contact: FC = (): ReactNode => {
    return (
        <>
            <Seo
                title='Contact'
                description='Commissions, print sales, licensing and exhibition loans. Reach the Morph studio in Bermondsey, London.'
                ogImage='/images/contact/closing.png'
            />

            <PageShell>
                <ContactMasthead />
                <ContactBody />
                <ContactClosing />
            </PageShell>
        </>
    )
}

export default Contact
